import * as React from "react"
import { createTheme, ThemeProvider } from '@mui/material/styles';


export default function MUIDataTableThemeProvider({ theme=null, children }) {
	if (!theme)
		return children

    return <ThemeProvider theme={createTheme({
		components: theme
	})}>
		{children}
    </ThemeProvider>
}
